import React from 'react';
import { Camera } from 'lucide-react';
import { Amenity } from '../types/amenity';
import S3Image from './S3Image';
import '../styles/AmenityCard.css';

interface AmenityCardProps {
  amenity: Amenity;
  workspaceId: string;
  onClick: () => void;
}

const AmenityCard: React.FC<AmenityCardProps> = ({
  amenity,
  workspaceId,
  onClick
}) => {
  const primaryImageId = amenity.imageIds && amenity.imageIds.length > 0 ? amenity.imageIds[0] : null;
  const imageCount = amenity.imageIds ? amenity.imageIds.length : 0;

  return (
    <div className="amenity-card" onClick={onClick}>
      {/* Image Section */}
      <div className="amenity-card-image">
        {primaryImageId ? (
          <>
            <S3Image
              workspaceId={workspaceId}
              imageId={primaryImageId}
              alt={amenity.title}
              className="amenity-image"
            />
            {imageCount > 1 && (
              <div className="amenity-image-count">
                <Camera size={14} />
                <span>{imageCount}</span>
              </div>
            )}
          </>
        ) : (
          <div className="amenity-placeholder">
            <Camera size={48} color="#9CA3AF" />
          </div>
        )}
        {/* Category Badge */}
        <div className="amenity-category-badge">
          {amenity.category}
        </div>
      </div>

      {/* Content Section */}
      <div className="amenity-card-content">
        <h3 className="amenity-title">{amenity.title}</h3>
        {amenity.description && (
          <div
            className="amenity-description"
            dangerouslySetInnerHTML={{
              __html: amenity.description.length > 120
                ? amenity.description.substring(0, 120) + '...'
                : amenity.description
            }}
          />
        )}
      </div>

      {/* View Details Button */}
      <div className="amenity-card-footer">
        <button className="amenity-view-btn">
          View Details
        </button>
      </div>
    </div>
  );
};

export default AmenityCard;
